import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import swal from 'sweetalert';
import _ from 'lodash';
import shortid from 'shortid';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';

class ReportReceipt extends React.Component {
    constructor() {
        super();
        this.state = {
            startDate: moment(`${new Date().getFullYear()}-01-01`),
            endDate: moment(`${new Date().getFullYear()}-12-31`),
            reportResult: {},
            loading: false,
        };
        this.search = this.search.bind(this);
        this.export = this.export.bind(this);
        this.grandTotal = {

        };
    }

    componentWillMount() {
        this.search();
    }

    async search() {
        const { endDate, startDate, loading } = this.state;
        if (loading) return;
        this.setState({ loading: true });
        this.grandTotal = {};
        try {
            const res = await fetch(`${spmfcloudFunctionUrl}/reports/bene-receipt?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`, {
                headers: {
                    'hash-token': this.props.hashToken,
                    'Content-Type': 'application/json',
                },
                cache: 'no-cache',
            });
            const json = await res.json();
            if (!res.ok) throw new Error(json.message);

            this.setState({ reportResult: json.records, loading: false });
        } catch (error) {
            swal({
                text: error.message,
                title: 'An error occured when getting report',
                dangerMode: true,
            });
            this.setState({ loading: false });
        }
    }

    async export() {
        try {
            await this.search();
            const { startDate, endDate } = this.state;
            let tableInText = "<table border='2px'><tr bgcolor='#87AFC6'>";
            const uri = 'data:application/vnd.ms-excel;base64,';
            const base64 = s => window.btoa(unescape(encodeURIComponent(s)));
            const table = document.getElementById('receiptTable');
            for (let j = 0; j < table.rows.length; j++) {
                tableInText = `${tableInText}${table.rows[j].innerHTML}</tr>`;
            }

            tableInText = `${tableInText}</table>`;
            tableInText = tableInText.replace(/<A[^>]*>|<\/A>/g, '');// remove links in your table
            tableInText = tableInText.replace(/<img[^>]*>/gi, ''); // remove images in your table
            tableInText = tableInText.replace(/<input[^>]*>|<\/input>/gi, ''); // remove input params

            const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Receipt</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>${tableInText}</body></html>`;
            const link = document.createElement('a');
            link.download = `ReceiptReport(${startDate.format('MMM-YYYY')}-${endDate.format('MMM-YYYY')}).xls`;
            link.href = `${uri}${base64(template)}`;
            document.body.appendChild(link);
            link.click();
        } catch (err) {
            swal({
                text: err.message,
                title: 'An error occured when exporting report',
                dangerMode: true,
            });
        }
    }

    render() {
        const { endDate, startDate, reportResult, loading } = this.state;
        const monthDiff = endDate.diff(startDate, 'months', true);
        const currentYear = new Date().getFullYear();
        let grandCountBene = 0;
        this.grandTotal = {};
        this.grandTotal.zTotal = { monthlyDetail: {} };
        /* this.grandTotal['yPri/Sec'] = {
            count: [],
            totalValue: 0,
            monthlyDetail: {},
            monthlyTotal: {},
        }; */
        const tbody = Object.keys(reportResult).map((key) => {
            let total = 0;
            const educationLevel = reportResult[key].For_Level__c; // beneficiaryInfo.Current_Education_Level__c;
            if (this.grandTotal[educationLevel] === undefined) {
                this.grandTotal[educationLevel] = {
                    count: [],
                    totalValue: 0,
                    monthlyDetail: {},
                    monthlyTotal: {},
                };
            }
            if (this.grandTotal[educationLevel].count.indexOf(key) <= -1) this.grandTotal[educationLevel].count.push(key);
            // if (this.grandTotal['yPri/Sec'].count.indexOf(key) <= -1 && (educationLevel === 'Primary' || educationLevel === 'Secondary')) this.grandTotal['yPri/Sec'].count.push(key);

            let exceptionStatus = '';

            if (reportResult[key].beneficiaryInfo.Exception_Case__c === true) {
                exceptionStatus = '✓'; // <i className="fa fa-check" />;
            } /* else if (reportResult[key].beneficiaryInfo.Approve_Exception__c === false) {
                exceptionStatus = 'X';
            } */

            return (
                <tr key={shortid.generate()}>
                    <th>{reportResult[key].beneficiaryInfo.ID_Number__c}</th>
                    <th>{reportResult[key].beneficiaryInfo.Name}</th>
                    <th>{reportResult[key].beneficiaryInfo.Birthdate ? moment().diff(reportResult[key].beneficiaryInfo.Birthdate, 'year') : null}</th>
                    <th>{/* reportResult[key].beneficiaryInfo.Approve_Exception__c ? <i className="fa fa-check" /> : 'No' */}{exceptionStatus}</th>
                    <th>{reportResult[key].For_Level__c}</th>
                    {_.times(Math.ceil(monthDiff), (index) => {
                        let newDate = startDate.clone();
                        newDate = newDate.add(index, 'month');
                        const value = reportResult[key][newDate.format('MMM-YYYY')] || 0;
                        total += value;
                        if (this.grandTotal[educationLevel].monthlyDetail[newDate.format('MMM-YYYY')] === undefined) {
                            this.grandTotal[educationLevel].monthlyDetail[newDate.format('MMM-YYYY')] = 0;
                        }
                        this.grandTotal[educationLevel].totalValue += value;
                        this.grandTotal[educationLevel].monthlyDetail[newDate.format('MMM-YYYY')] += value;

                        /*
                        // This is for yPri/Sec Row
                        if (educationLevel === 'Primary' || educationLevel === 'Secondary') {
                            if (this.grandTotal['yPri/Sec'].monthlyDetail[newDate.format('MMM-YYYY')] === undefined) {
                                this.grandTotal['yPri/Sec'].monthlyDetail[newDate.format('MMM-YYYY')] = 0;
                            }
                            this.grandTotal['yPri/Sec'].totalValue += value;
                            this.grandTotal['yPri/Sec'].monthlyDetail[newDate.format('MMM-YYYY')] += value;
                        }
                        */
                        // This is for grand total
                        if (this.grandTotal.zTotal.monthlyDetail[newDate.format('MMM-YYYY')] === undefined) {
                            this.grandTotal.zTotal.monthlyDetail[newDate.format('MMM-YYYY')] = 0;
                        }
                        this.grandTotal.zTotal.monthlyDetail[newDate.format('MMM-YYYY')] += value;
                        return (
                            <td key={shortid.generate()} style={{ backgroundColor: value > 0 ? '#00FF00' : 'transparent' }}>
                                {value}
                            </td>
                        );
                    })}
                    <td style={{ backgroundColor: '#888', color: '#fff' }}>{total}</td>
                </tr>
            );
        });

        return (
            <div className="row card" id="receiptReport">
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <h4 style={{ flex: 1 }}>Receipt Report</h4>
                    <div style={{ width: 100 }}>
                        <p>Quick Jump:</p>
                        <select
                            className="form-control"
                            onChange={(val) => {
                                this.setState({
                                    startDate: moment(`${val.target.value}-01-01`),
                                    endDate: moment(`${val.target.value}-12-31`),
                                }, this.search);
                            }}
                        >
                            {_.times(11, index => (
                                <option key={index} value={currentYear - index + 1} selected={index === 1}>{currentYear - index + 1}</option>
                            ))}

                        </select>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-5">
                    <p>Start Date</p>
                    <DatePicker
                        name="DatePicker"
                        selected={startDate}
                        dateFormat="DD-MMM-YYYY"
                        onChange={value => this.setState({ startDate: value })}
                        placeholderText="Date of Birth"
                        className="form-control fullw"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                    />
                </div>
                <div className="col-lg-3 col-sm-5">
                    <p>End Date</p>
                    <DatePicker
                        name="Birthdate"
                        selected={endDate}
                        dateFormat="DD-MMM-YYYY"
                        onChange={value => this.setState({ endDate: value })}
                        placeholderText="Date of Birth"
                        className="form-control fullw"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                    />
                </div>
                <div className="col-lg-4 col-sm-2 col-lg-2" style={{ paddingTop: 30, display: 'flex', flexDirection: 'row' }}>
                    <button
                        type="button"
                        className="btn btn-default btn-fill"
                        onClick={this.search}
                        disabled={loading}
                    >
                        <i className="fa fa-search" />
                        Search
                    </button>
                    <button
                        type="button"
                        className="btn btn-info btn-fill"
                        onClick={this.export}
                        disabled={loading}
                    >
                        <i className="fa fa-download" />
                        Export
                    </button>
                </div>
                <div className="clearfix" />
                <div className="col-lg-12 text-center">
                    {loading ? (
                        <i className="fa fa-1x fa-spinner fa-spin text-center" />
                    ) : null}
                </div>
                <div className="table-responsive">
                    <table className="table table-striped" id="receiptTable">
                        <thead>
                            <tr>
                                <th colSpan="2" style={{ textAlign: 'center' }}>Beneficiary Info</th>
                                <th colSpan={Math.ceil(monthDiff)} style={{ textAlign: 'center' }}>Scheduled Payout Date</th>
                            </tr>
                            <tr className="small-font">
                                <th style={{ textAlign: 'left' }}>Id Number</th>
                                <th style={{ textAlign: 'left' }}>Full Name</th>
                                <th style={{ textAlign: 'left' }}>Age</th>
                                <th style={{ textAlign: 'left' }}>Exception</th>
                                <th style={{ textAlign: 'left' }}>Education Lvl</th>
                                {_.times(Math.ceil(monthDiff), (index) => {
                                    let newDate = startDate.clone();
                                    newDate = newDate.add(index, 'month');
                                    return <th key={shortid.generate()}>{newDate.format('MMM-YYYY')}</th>;
                                })}
                                <th>Grand Total</th>
                            </tr>
                        </thead>
                        <tbody>{tbody}</tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={3} rowSpan={Object.keys(this.grandTotal).length + 2} style={{ backgroundColor: '#eee' }}>
                                    Grand Total
                                </td>
                            </tr>
                            {Object.keys(this.grandTotal).sort().map((educationLevel) => {
                                let total = 0;
                                if (this.grandTotal[educationLevel].count) {
                                    if (educationLevel !== 'yPri/Sec') grandCountBene += this.grandTotal[educationLevel].count.length;
                                }
                                const everyTd = Object.keys(this.grandTotal[educationLevel].monthlyDetail).map((key) => {
                                    total += this.grandTotal[educationLevel].monthlyDetail[key];
                                    return (
                                        <td key={`${educationLevel}${key}`} style={{ backgroundColor: this.grandTotal[educationLevel].monthlyDetail[key] > 0 ? '#00FF00' : 'transparent' }}>
                                            {this.grandTotal[educationLevel].monthlyDetail[key]}
                                        </td>
                                    );
                                });
                                const bgColor = {
                                    zTotal: '#888',
                                    'yPri/Sec': '#ccc',
                                };
                                return (
                                    <tr key={shortid.generate()} style={{ backgroundColor: bgColor[educationLevel] || '#fff' }}>
                                        <td style={{ textAlign: 'left' }}>{['zTotal', 'yPri/Sec'].indexOf(educationLevel) >= 0 ? educationLevel.substr(1) : educationLevel}</td>
                                        <td>{this.grandTotal[educationLevel].count ? this.grandTotal[educationLevel].count.length : grandCountBene}</td>
                                        {everyTd}
                                        <td style={{ color: '#fff', backgroundColor: '#444' }}>
                                            {total}
                                        </td>
                                    </tr>
                                );
                            })}

                        </tfoot>
                    </table>
                </div>
                <iframe ref={(c) => { this.iFrame = c; }} id="txtArea1" style={{ display: 'none' }} title="excel" />
            </div>
        );
    }
}

ReportReceipt.propTypes = {
    hashToken: PropTypes.string.isRequired,
};

ReportReceipt.defaultProps = {
};

export default ReportReceipt;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/DashBoard/ReportReceipt.js
// module id = 991
// module chunks = 0